import { TicketType } from './ticket-type-entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { marker } from 'src/app/tools/models/entities/marker';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { TicketBatchTicket } from './ticket-batch-ticket';


export class Ticket extends BaseEntity {
    id                      : number;
    upTicket                : Ticket;
    subTicket               : Ticket;
    asset                   : Asset;

    branch                  : Branch;
    partner                 : Partner;
    partnerReference        : string;

    ticketType              : TicketType;
    progressLevel           : number;

    creationDate            : Date;
    createdByRole           : Role;
    createdByPerson         : Person;
    creationComment         : string;


    qualificationSlaDate    : Date;
    qualificationDate       : Date;
    qualifiededByRole       : Role;
    qualifiedByPerson       : Person;
    qualificationComment    : string;
    requestedProcessingDate : Date;
    priority                : number = 0;

    processingSlaDate       : Date;

    closingSlaDate          : Date;
    closingDate             : Date;
    closedByRole            : Role ;
    closedByPerson          : Person;
    closingComment          : string

    
    // Transient
    point    : marker;
    ticketBatchTickets : TicketBatchTicket[]; 

// be my required for futur use
//----------------------------------
/*
assignmentDate           : Date;
assignedToRole           : Role;
assignedToPerson         : Person;
processingDate           : Date;
duration                 : number;
processingComment        : string;
*/
}

